<template>
  <div class="main">
    <div id="header">
      <Headerbar />
      <Sidebar
        @fontBig="changeFontBig"
        @fontMiddle="changeFontMiddle"
        @fontSmall="changeFontSmall"
      />

      <Banner />
    </div>
    <div
      id="ContentHero"
      :class="{ hero_bg_page: isFraudSelfCheck, hero_bg_page_2: isFraudNotice }"
    >
      <div id="Content">
        <a id="main" href="#main" accesskey="C" title="網頁內容區塊資訊">:::</a>
        <div class="bread" v-show="!isHome">
          <BreadCrumb />
        </div>
        <router-view />
      </div>
    </div>
    <div id="footer">
      <FooterTop />
      <FooterBottom />
    </div>
    <div>
      <GoToTop />
    </div>
  </div>
</template>

<script>
import { provide, ref, reactive, watch, computed } from "vue";
import { useRoute } from "vue-router";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
UIkit.use(Icons);

import Headerbar from "./components/Home/Headerbar2.vue";
import Sidebar from "./components/Home/Sidebar2.vue";
import Banner from "./components/Home/Banner.vue";
import FooterTop from "./components/Home/FooterTop.vue";
import FooterBottom from "./components/Home/FooterBottom.vue";
import GoToTop from "./components/Home/GoToTop.vue";
import BreadCrumb from "@/components/Breadcrumb.vue";

export default {
  name: "App",
  components: {
    GoToTop,
    Headerbar,
    Banner,
    Sidebar,
    FooterTop,
    FooterBottom,
    BreadCrumb,
  },
  setup() {
    //  無障礙文字設定
    const fontSize = reactive({
      p: 1.125,
      h3: 1.688,
      h4: 1.375,
      h5: 1.25,
    });
    //  無障礙大文字設定
    function changeFontBig() {
      fontSize.p = 1.25;
      fontSize.h3 = 1.813;
      fontSize.h4 = 1.5;
      fontSize.h5 = 1.375;
    }
    //  無障礙中文字設定
    function changeFontMiddle() {
      fontSize.p = 1.125;
      fontSize.h3 = 1.688;
      fontSize.h4 = 1.375;
      fontSize.h5 = 1.25;
    }
    //  無障礙小文字設定
    function changeFontSmall() {
      fontSize.p = 1;
      fontSize.h3 = 1.563;
      fontSize.h4 = 1.25;
      fontSize.h5 = 1.125;
    }
    //  無障礙文字傳遞到子層設定
    provide("fontSize", fontSize);

    const route = useRoute();
    const isHome = ref();
    settingHomePage();

    // 海外就業安全自我檢核頁面才需要顯示背景圖
    const isFraudSelfCheck = computed(
      () => route.name === "fraud_prevention_self_check",
    );

    // 打工度假代辦服務應注意事項頁面才需要顯示背景圖
    const isFraudNotice = computed(
      () => route.name === "fraud_prevention_notice",
    );

    // 判斷是否為首頁
    function settingHomePage() {
      isHome.value =
        route.path === "/index" || route.path === "/" ? true : false;
    }

    // 判斷麵包屑是否渲染
    watch(
      // 監聽route路徑，一有變更就更新麵包屑
      () => route.path,
      () => {
        //監聽 國家id的值
        settingHomePage();
      },
    );

    return {
      changeFontBig,
      changeFontMiddle,
      changeFontSmall,
      fontSize,
      isHome,
      isFraudSelfCheck,
      isFraudNotice,
    };
  },
};
</script>

<style lang="scss">
@import "./assets/uikit/css/uikit.css";
.main {
  a {
    &:focus {
      outline: 2px dotted black;
    }
  }
  a:active,
  a:hover,
  a:focus {
    background: #ffbf47;
    color: #000;
    font-weight: 700;
  }
  #ContentHero {
    &.hero_bg_page {
      position: relative;
      z-index: 0;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: -1;
        height: 900px;
        background: linear-gradient(
            180deg,
            rgba(9, 38, 66, 0.52),
            rgba(220, 220, 235, 0.55) 30%,
            rgba(9, 38, 66, 0) 55%
          ),
          url("./img/bg.png") top / cover no-repeat;
      }

      #main,
      .bread .ant-breadcrumb,
      .bread .ant-breadcrumb a,
      .bread .ant-breadcrumb span,
      .bread .ant-breadcrumb-separator {
        color: rgba(255, 255, 255, 0.9);
      }
    }

    &.hero_bg_page_2 {
      position: relative;
      z-index: 0;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: -1;
        height: 900px;
        background: linear-gradient(
            180deg,
            rgba(9, 38, 66, 0.52),
            rgba(220, 220, 235, 0.55) 30%,
            rgba(9, 38, 66, 0) 55%
          ),
          url("./img/bg_2.png") top / cover no-repeat;
      }

      #main,
      .bread .ant-breadcrumb,
      .bread .ant-breadcrumb a,
      .bread .ant-breadcrumb span,
      .bread .ant-breadcrumb-separator {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  #Content {
    #main {
      display: table-caption;
    }
    width: 75%;
    margin: 0 auto;
    @include md {
      width: 90%;
      padding: 0;
    }
    .bread {
      display: flex;
      padding: 20px 0 10px;
      span {
        font-weight: 600;
      }
    }
  }
  .flag {
    width: 35px;
  }
}
</style>
